import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImage12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconImage12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Image12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M10.5 2h-9a.5.5 0 0 0-.5.5v3.973L3.715 4.59l.32-.222.294.257L8.12 7.94 11 7.06V2.5a.5.5 0 0 0-.5-.5M12 7.411V2.5A1.5 1.5 0 0 0 10.5 1h-9A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h9A1.5 1.5 0 0 0 12 9.5zm-1 .694-2.854.873-.266.082-.21-.184-3.705-3.243L1 7.69V9.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM8.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Image12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconImage12);
